import { render, staticRenderFns } from "./ContactSendModal.vue?vue&type=template&id=95ca2bf0&scoped=true"
import script from "./ContactSendModal.vue?vue&type=script&lang=js"
export * from "./ContactSendModal.vue?vue&type=script&lang=js"
import style0 from "./ContactSendModal.vue?vue&type=style&index=0&id=95ca2bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ca2bf0",
  null
  
)

export default component.exports